import React, { FC } from 'react';
import { useField, UseFieldConfig } from 'react-final-form';

import TreeSelect, { IProps as IInputProps } from '../../Fields/AntTreeSelect';

type IProps = {
  name: string;
  description?: string;
  useFieldConfig?: UseFieldConfig<string>;
} & IInputProps;

const FormAntTreeSelect: FC<IProps> = ({ name, useFieldConfig, description, ...props }) => {
  const {
    input,
    meta: { touched, error, invalid }
  } = useField(name, useFieldConfig);

  // // Адаптер под mts-ds
  // input.onMtsChange = input.onChange;
  // input.onMtsFocus = input.onFocus;
  // input.onMtsBlur = input.onBlur;

  const message = touched && error ? error : description;

  const isValid = touched && invalid ? !Boolean(error) : undefined;

  return (
    <TreeSelect
      description={message}
      size={'large'}
      style={{ width: '100%' }}
      valid={isValid}
      treeDefaultExpandAll
      allowClear
      {...input}
      {...props}
    />
  );
};

export default FormAntTreeSelect;
